import { useState, useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";
import "./Aventuras.css";
import ImgVideos from "./assets/img/imagenes home/ImgVideos.jpeg";
import YouTubePlaylistEmbed from "../components/YouTubePlaylistEmbed";
import CardCarousel from "../components/CardCarousel";
import AppCardVideo from "../components/AppCardVideo";
import ContenidoExtra from "../components/ContenidoExtra";
import { getConfigPagina, getPlaylistVideos, mergeVideoDescripciones, isApiConfigured } from "../services/api";

const DEFAULT_TITULO = "Aventuras";
const DEFAULT_SUBTITULO = "Vive las aventuras de Balloon y Ben: cada episodio es un viaje lleno de música, aprendizaje y mucha diversión. Acompaña a Ben y sus amigos mientras descubren el mundo natural y se convierten en Guardianes del Planeta.";
const DEFAULT_PLAYLIST = null;
const DEFAULT_CAPITULOS_TITULO = "Los mejores capítulos";
const DEFAULT_CAPITULOS_SUBTITULO = "Elige un episodio y vive la aventura completa.";

const defaultCapitulos = Array(6).fill({ thumbnail: ImgVideos, title: "", descripcion: "", videoId: null });

export default function Aventuras() {
  const [config, setConfig] = useState({
    titulo: null,
    subtitulo: null,
    contenido_extra: null,
    playlist_youtube_id: null,
    lista_titulo: null,
    lista_subtitulo: null,
  });
  const [capitulos, setCapitulos] = useState(defaultCapitulos);
  const shouldReduceMotion = useReducedMotion();

  const sectionVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.6,
        ease: [0.22, 1, 0.36, 1],
        staggerChildren: shouldReduceMotion ? 0 : 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: shouldReduceMotion ? 0.2 : 0.5, ease: "easeOut" },
    },
  };

  useEffect(() => {
    if (!isApiConfigured()) return;
    getConfigPagina("aventuras")
      .then((cfg) => {
        if (cfg) setConfig(cfg);
        return Promise.all([
          cfg,
          cfg?.playlist_youtube_id ? getPlaylistVideos(cfg.playlist_youtube_id, 12) : [],
        ]);
      })
      .then(([cfg, data]) => {
        if (data.length > 0) setCapitulos(mergeVideoDescripciones(data, cfg?.videos_descripciones));
      })
      .catch(() => {});
  }, []);

  return (
    <div className="aventuras">
      <motion.div
        initial="hidden"
        animate="show"
        variants={sectionVariants}
      >
        <motion.div className="aventuras-wrapper" variants={itemVariants}>
          <h1 className="Aventuras-title">{config.titulo || DEFAULT_TITULO}</h1>
        </motion.div>
        <motion.div className="aventuras-descripciones" variants={itemVariants}>
          <h3 className="aventuras-descripcion">{config.subtitulo || DEFAULT_SUBTITULO}</h3>
        </motion.div>
        <ContenidoExtra html={config.contenido_extra} variants={itemVariants} />
        <motion.div variants={itemVariants}>
          <YouTubePlaylistEmbed
            playlistId={config.playlist_youtube_id || DEFAULT_PLAYLIST}
            title="Capítulos de Balloon y Ben"
          />
        </motion.div>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={sectionVariants}
      >
        <motion.h2 className="aventuras-capitulos-title" variants={itemVariants}>
          {config.lista_titulo || DEFAULT_CAPITULOS_TITULO}
        </motion.h2>
        <motion.p className="aventuras-capitulos-subtitle" variants={itemVariants}>
          {config.lista_subtitulo || DEFAULT_CAPITULOS_SUBTITULO}
        </motion.p>
        <motion.div variants={itemVariants}>
          <CardCarousel
            items={capitulos}
            itemsPerSlide={3}
            renderItem={(c, j) => (
              <AppCardVideo
                key={j}
                thumbnail={c.thumbnail}
                title={c.title}
                descripcion={c.descripcion}
                videoId={c.videoId}
              />
            )}
          />
        </motion.div>
      </motion.div>
    </div>
  );
}
